/**
 * On-screen event ticker (spec rule 7): visible with ?debug_analytics=1 so the
 * whole QA matrix is verifiable on localhost without any analytics account.
 * Shows the newest events with their ROUTING annotation.
 */

const MAX_ROWS = 10
let host: HTMLElement | null = null

export function tickerEnabled(): boolean {
  return new URLSearchParams(location.search).get('debug_analytics') === '1'
}

function ensureHost(): HTMLElement {
  if (host && host.isConnected) return host
  host = document.createElement('div')
  host.setAttribute('data-analytics-ticker', '')
  host.setAttribute('aria-hidden', 'true')
  host.style.cssText =
    'position:fixed;right:12px;top:12px;z-index:70;width:380px;max-width:calc(100vw - 24px);' +
    "font-family:'Geist Mono',monospace;font-size:10.5px;line-height:1.45;color:#97A79D;" +
    'background:rgba(7,10,8,0.92);border:1px solid #1E2A24;border-radius:8px;padding:8px 10px;' +
    'pointer-events:none;white-space:nowrap;overflow:hidden;'
  const title = document.createElement('div')
  title.textContent = 'ANALYTICS TICKER (dev)'
  title.style.cssText = 'color:#2BE07A;letter-spacing:.08em;font-size:9.5px;margin-bottom:4px;'
  host.appendChild(title)
  document.body.appendChild(host)
  return host
}

export function pushTicker(route: string, name: string, params: Record<string, unknown>): void {
  const container = ensureHost()
  const row = document.createElement('div')
  const compact = Object.entries(params)
    .filter(([k]) => !['session_id', 'schema_version'].includes(k))
    .map(([k, v]) => `${k}=${String(v)}`)
    .join(' ')
  const badge = route === 'both' ? 'GA+PH' : route.toUpperCase()
  row.textContent = `${badge.padEnd(5)} ${name} ${compact}`
  row.style.cssText = 'overflow:hidden;text-overflow:ellipsis;'
  container.appendChild(row)
  while (container.children.length > MAX_ROWS + 1) container.children[1].remove()
}
